module.exports = __webpack_public_path__ + "integrationBanner.178cf0d86a9ab7670b825e836008f694.png";